import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import OurStoryPageStyle from "./our-story-page.module.scss"

const HeroContent = () => (
    <StaticQuery query={graphql`
        query HeroAboutUs{
            contentfulOurStoryPage{
                ourStoryReference{
                  hero{
                    headline{
                      headline
                    }
                    paragraph{
                      json
                    }
                  }
                }
              }
        }
    `}
    render ={data => (
    <div className={OurStoryPageStyle.heroContentDiv}>
        <h1 className={OurStoryPageStyle.heroTitle}>{data.contentfulOurStoryPage.ourStoryReference.hero.headline.headline}</h1>
        <div className={OurStoryPageStyle.heroDescription}>
            {documentToReactComponents(data.contentfulOurStoryPage.ourStoryReference.hero.paragraph.json)}
        </div>
    </div>
    )}
    />
)

export default HeroContent